module.exports = __webpack_public_path__ + "img/restaurante.dd286c06.png";